import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstanceeghlbkcb6su6 as Companion_getInstance,
  Angle36m0cdko0c63j as Angle,
  Angle__toString_impl_786qky3amgxlk310y0l as Angle__toString_impl_786qky,
  Angle__hashCode_impl_szcndt7z0bvq6vi9u2 as Angle__hashCode_impl_szcndt,
  _Angle___init__impl__g23q1mpxbjdjfwrarw as _Angle___init__impl__g23q1m,
} from './Angle.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  zipWithNext1coaflhq3atps as zipWithNext,
  sum21i2pabt6cxsw as sum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { coerceIn10f36k81le1mm as coerceIn } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { toInt5qdj874w69jh as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { toString10m9tj9xt75j5 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { drop336950s126lmj as drop } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp.vcy_1 = new (LinearGradient())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function LinearGradient$closestColor$lambda(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.jaz_1 + b.iaz_1.jaz_1) / 2;
}
function LinearGradient$closestColor$lambda_0(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.kaz_1 + b.iaz_1.kaz_1) / 2;
}
function LinearGradient$closestColor$lambda_1(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.laz_1 + b.iaz_1.laz_1) / 2;
}
function LinearGradient$closestColor$lambda_2(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.maz_1 + b.iaz_1.maz_1) / 2;
}
var LinearGradientClass;
function LinearGradient() {
  if (LinearGradientClass === VOID) {
    class $ {
      constructor(stops, angle, screenStatic) {
        Companion_getInstance_0();
        angle = angle === VOID ? Companion_getInstance().gb2_1 : angle;
        screenStatic = screenStatic === VOID ? false : screenStatic;
        this.oaz_1 = stops;
        this.paz_1 = angle;
        this.qaz_1 = screenStatic;
      }
      wcy(mapper) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.oaz_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = mapper(item.iaz_1);
          var tmp$ret$1 = item.xcy(VOID, tmp$ret$0);
          destination.v(tmp$ret$1);
        }
        return this.ycy(destination);
      }
      db2() {
        if (this.oaz_1.i1())
          return Companion_getInstance_1().saz_1;
        if (this.oaz_1.p1() === 1)
          return this.oaz_1.q1(0).iaz_1;
        var tmp = asSequence(this.oaz_1);
        var tmp_0 = sum(zipWithNext(tmp, LinearGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.oaz_1);
        var tmp_2 = sum(zipWithNext(tmp_1, LinearGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.oaz_1);
        var tmp_4 = sum(zipWithNext(tmp_3, LinearGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.oaz_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, LinearGradient$closestColor$lambda_2)));
      }
      zcy(stops, angle, screenStatic) {
        return new (LinearGradient())(stops, angle, screenStatic);
      }
      ycy(stops, angle, screenStatic, $super) {
        stops = stops === VOID ? this.oaz_1 : stops;
        angle = angle === VOID ? this.paz_1 : angle;
        screenStatic = screenStatic === VOID ? this.qaz_1 : screenStatic;
        return $super === VOID ? this.zcy(stops, angle, screenStatic) : $super.zcy.call(this, stops, new (Angle())(angle), screenStatic);
      }
      toString() {
        return 'LinearGradient(stops=' + toString(this.oaz_1) + ', angle=' + Angle__toString_impl_786qky(this.paz_1) + ', screenStatic=' + this.qaz_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.oaz_1);
        result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.paz_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.qaz_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LinearGradient()))
          return false;
        if (!equals(this.oaz_1, other.oaz_1))
          return false;
        if (!equals(this.paz_1, other.paz_1))
          return false;
        if (!(this.qaz_1 === other.qaz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LinearGradient');
    LinearGradientClass = $;
  }
  return LinearGradientClass;
}
function byteize($this, _this__u8e3s4) {
  return coerceIn(numberToInt(_this__u8e3s4 * 255), 0, 255);
}
function floatize($this, _this__u8e3s4) {
  return coerceIn(_this__u8e3s4, 0, 255) / 255;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.saz_1 = new (Color())();
        this.taz_1 = new (Color())(1.0, 1.0, 1.0, 1.0);
        this.uaz_1 = new (Color())(1.0, 0.5, 0.5, 0.5);
        this.vaz_1 = new (Color())(1.0, 0.0, 0.0, 0.0);
        this.waz_1 = new (Color())(1.0, 1.0, 0.0, 0.0);
        this.xaz_1 = new (Color())(1.0, 1.0, 0.5, 0.0);
        this.yaz_1 = new (Color())(1.0, 1.0, 1.0, 0.0);
        this.zaz_1 = new (Color())(1.0, 0.0, 1.0, 0.0);
        this.ab0_1 = new (Color())(1.0, 0.0, 1.0, 1.0);
        this.bb0_1 = new (Color())(1.0, 0.0, 0.0, 1.0);
        this.cb0_1 = new (Color())(1.0, 1.0, 0.0, 1.0);
      }
      acz(amount) {
        return new (Color())(1.0, amount, amount, amount);
      }
      bcz(value) {
        return new (Color())(1.0, floatize(this, value >> 16 & 255), floatize(this, value >> 8 & 255), floatize(this, value & 255));
      }
      ccz(value) {
        return this.bcz(toInt(replace(value, '#', ''), 16));
      }
      dcz(left, right, ratio) {
        var invRatio = 1 - ratio;
        return new (Color())(left.jaz_1 * invRatio + right.jaz_1 * ratio, left.kaz_1 * invRatio + right.kaz_1 * ratio, left.laz_1 * invRatio + right.laz_1 * ratio, left.maz_1 * invRatio + right.maz_1 * ratio);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ColorClass;
function Color() {
  if (ColorClass === VOID) {
    class $ {
      constructor(alpha, red, green, blue) {
        Companion_getInstance_1();
        alpha = alpha === VOID ? 0.0 : alpha;
        red = red === VOID ? 0.0 : red;
        green = green === VOID ? 0.0 : green;
        blue = blue === VOID ? 0.0 : blue;
        this.jaz_1 = alpha;
        this.kaz_1 = red;
        this.laz_1 = green;
        this.maz_1 = blue;
      }
      wcy(mapper) {
        // Inline function 'kotlin.let' call
        return mapper(this);
      }
      db2() {
        return this;
      }
      ecz(alpha) {
        return this.fcz(alpha * this.jaz_1);
      }
      gcz() {
        return byteize(Companion_getInstance_1(), this.jaz_1) << 24 | byteize(Companion_getInstance_1(), this.kaz_1) << 16 | byteize(Companion_getInstance_1(), this.laz_1) << 8 | byteize(Companion_getInstance_1(), this.maz_1);
      }
      hcz(ratio) {
        return this.fcz(VOID, this.kaz_1 * (1.0 - ratio), this.laz_1 * (1.0 - ratio), this.maz_1 * (1.0 - ratio));
      }
      icz(ratio) {
        return this.fcz(VOID, this.kaz_1 + (1.0 - this.kaz_1) * ratio, this.laz_1 + (1.0 - this.laz_1) * ratio, this.maz_1 + (1.0 - this.maz_1) * ratio);
      }
      jcz(alpha) {
        return this.fcz(alpha);
      }
      kcz() {
        return (this.kaz_1 + this.laz_1 + this.maz_1) / 3.0;
      }
      bb3() {
        // Inline function 'kotlin.math.sqrt' call
        var x = this.kaz_1 * this.kaz_1 * 0.299 + this.laz_1 * this.laz_1 * 0.587 + this.maz_1 * this.maz_1 * 0.114;
        return Math.sqrt(x);
      }
      lcz() {
        return byteize(Companion_getInstance_1(), this.kaz_1);
      }
      mcz() {
        return byteize(Companion_getInstance_1(), this.laz_1);
      }
      ncz() {
        return byteize(Companion_getInstance_1(), this.maz_1);
      }
      ocz(ratio) {
        return Companion_getInstance_1().dcz(this, Companion_getInstance_1().taz_1, ratio);
      }
      pcz(ratio) {
        return Companion_getInstance_1().dcz(this, Companion_getInstance_1().vaz_1, ratio);
      }
      qcz(ratio) {
        return this.kcz() > 0.5 ? this.pcz(ratio) : this.ocz(ratio);
      }
      rcz() {
        var tmp;
        if (this.kaz_1 > this.laz_1 && this.kaz_1 > this.maz_1) {
          var tmp_0 = this.laz_1 - this.maz_1;
          var tmp0 = this.kaz_1;
          // Inline function 'kotlin.math.max' call
          var b = this.laz_1;
          var tmp0_0 = Math.max(tmp0, b);
          // Inline function 'kotlin.math.max' call
          var b_0 = this.maz_1;
          var tmp_1 = Math.max(tmp0_0, b_0);
          var tmp0_1 = this.kaz_1;
          // Inline function 'kotlin.math.min' call
          var b_1 = this.laz_1;
          var tmp0_2 = Math.min(tmp0_1, b_1);
          // Inline function 'kotlin.math.min' call
          var b_2 = this.maz_1;
          tmp = tmp_0 / (tmp_1 - Math.min(tmp0_2, b_2));
        } else if (this.laz_1 > this.kaz_1 && this.laz_1 > this.maz_1) {
          var tmp_2 = this.maz_1 - this.kaz_1;
          var tmp0_3 = this.kaz_1;
          // Inline function 'kotlin.math.max' call
          var b_3 = this.laz_1;
          var tmp0_4 = Math.max(tmp0_3, b_3);
          // Inline function 'kotlin.math.max' call
          var b_4 = this.maz_1;
          var tmp_3 = Math.max(tmp0_4, b_4);
          var tmp0_5 = this.kaz_1;
          // Inline function 'kotlin.math.min' call
          var b_5 = this.laz_1;
          var tmp0_6 = Math.min(tmp0_5, b_5);
          // Inline function 'kotlin.math.min' call
          var b_6 = this.maz_1;
          tmp = tmp_2 / (tmp_3 - Math.min(tmp0_6, b_6)) + 2;
        } else if (this.maz_1 > this.laz_1 && this.maz_1 > this.kaz_1) {
          var tmp_4 = this.kaz_1 - this.laz_1;
          var tmp0_7 = this.kaz_1;
          // Inline function 'kotlin.math.max' call
          var b_7 = this.laz_1;
          var tmp0_8 = Math.max(tmp0_7, b_7);
          // Inline function 'kotlin.math.max' call
          var b_8 = this.maz_1;
          var tmp_5 = Math.max(tmp0_8, b_8);
          var tmp0_9 = this.kaz_1;
          // Inline function 'kotlin.math.min' call
          var b_9 = this.laz_1;
          var tmp0_10 = Math.min(tmp0_9, b_9);
          // Inline function 'kotlin.math.min' call
          var b_10 = this.maz_1;
          tmp = tmp_4 / (tmp_5 - Math.min(tmp0_10, b_10)) + 4;
        } else {
          tmp = 0.0;
        }
        // Inline function 'kotlin.let' call
        var it = tmp;
        var tmp_6 = _Angle___init__impl__g23q1m((it + 6.0) % 6.0 / 6.0);
        // Inline function 'kotlin.run' call
        var tmp0_11 = this.kaz_1;
        // Inline function 'kotlin.math.min' call
        var b_11 = this.laz_1;
        var tmp0_12 = Math.min(tmp0_11, b_11);
        // Inline function 'kotlin.math.min' call
        var b_12 = this.maz_1;
        var min = Math.min(tmp0_12, b_12);
        var tmp0_13 = this.kaz_1;
        // Inline function 'kotlin.math.max' call
        var b_13 = this.laz_1;
        var tmp0_14 = Math.max(tmp0_13, b_13);
        // Inline function 'kotlin.math.max' call
        var b_14 = this.maz_1;
        var max = Math.max(tmp0_14, b_14);
        var tmp$ret$19 = max === 0.0 ? 0.0 : (max - min) / max;
        return new (HSPColor())(this.jaz_1, tmp_6, tmp$ret$19, this.bb3());
      }
      raz() {
        return 'rgba(' + this.lcz() + ', ' + this.mcz() + ', ' + this.ncz() + ', ' + this.jaz_1 + ')';
      }
      naz() {
        // Inline function 'kotlin.toUInt' call
        var this_0 = this.gcz();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        return '#' + drop(padStart(toString_0(tmp$ret$0, 16), 8, _Char___init__impl__6a9atx(48)), 2);
      }
      scz(alpha, red, green, blue) {
        return new (Color())(alpha, red, green, blue);
      }
      fcz(alpha, red, green, blue, $super) {
        alpha = alpha === VOID ? this.jaz_1 : alpha;
        red = red === VOID ? this.kaz_1 : red;
        green = green === VOID ? this.laz_1 : green;
        blue = blue === VOID ? this.maz_1 : blue;
        return $super === VOID ? this.scz(alpha, red, green, blue) : $super.scz.call(this, alpha, red, green, blue);
      }
      toString() {
        return 'Color(alpha=' + this.jaz_1 + ', red=' + this.kaz_1 + ', green=' + this.laz_1 + ', blue=' + this.maz_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.jaz_1);
        result = imul(result, 31) + getNumberHashCode(this.kaz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.laz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.maz_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Color()))
          return false;
        if (!equals(this.jaz_1, other.jaz_1))
          return false;
        if (!equals(this.kaz_1, other.kaz_1))
          return false;
        if (!equals(this.laz_1, other.laz_1))
          return false;
        if (!equals(this.maz_1, other.maz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Color', Color);
    ColorClass = $;
  }
  return ColorClass;
}
function applyAlpha(_this__u8e3s4, alpha) {
  return _this__u8e3s4.wcy((it) => it.ecz(alpha));
}
var GradientStopClass;
function GradientStop() {
  if (GradientStopClass === VOID) {
    class $ {
      constructor(ratio, color) {
        this.haz_1 = ratio;
        this.iaz_1 = color;
      }
      tcz(ratio, color) {
        return new (GradientStop())(ratio, color);
      }
      xcy(ratio, color, $super) {
        ratio = ratio === VOID ? this.haz_1 : ratio;
        color = color === VOID ? this.iaz_1 : color;
        return $super === VOID ? this.tcz(ratio, color) : $super.tcz.call(this, ratio, color);
      }
      toString() {
        return 'GradientStop(ratio=' + this.haz_1 + ', color=' + this.iaz_1.toString() + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.haz_1);
        result = imul(result, 31) + this.iaz_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GradientStop()))
          return false;
        if (!equals(this.haz_1, other.haz_1))
          return false;
        if (!this.iaz_1.equals(other.iaz_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GradientStop');
    GradientStopClass = $;
  }
  return GradientStopClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        this.ucz_1 = 0.299;
        this.vcz_1 = 0.587;
        this.wcz_1 = 0.114;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var HSPColorClass;
function HSPColor() {
  if (HSPColorClass === VOID) {
    class $ {
      constructor(alpha, hue, saturation, brightness) {
        alpha = alpha === VOID ? 1.0 : alpha;
        hue = hue === VOID ? _Angle___init__impl__g23q1m(0.0) : hue;
        saturation = saturation === VOID ? 0.0 : saturation;
        brightness = brightness === VOID ? 0.0 : brightness;
        this.xcz_1 = alpha;
        this.ycz_1 = hue;
        this.zcz_1 = saturation;
        this.ad0_1 = brightness;
      }
      toString() {
        return 'HSPColor(alpha=' + this.xcz_1 + ', hue=' + Angle__toString_impl_786qky(this.ycz_1) + ', saturation=' + this.zcz_1 + ', brightness=' + this.ad0_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.xcz_1);
        result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.ycz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.zcz_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.ad0_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HSPColor()))
          return false;
        if (!equals(this.xcz_1, other.xcz_1))
          return false;
        if (!equals(this.ycz_1, other.ycz_1))
          return false;
        if (!equals(this.zcz_1, other.zcz_1))
          return false;
        if (!equals(this.ad0_1, other.ad0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HSPColor', HSPColor);
    HSPColorClass = $;
  }
  return HSPColorClass;
}
function RadialGradient$closestColor$lambda(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.jaz_1 + b.iaz_1.jaz_1) / 2;
}
function RadialGradient$closestColor$lambda_0(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.kaz_1 + b.iaz_1.kaz_1) / 2;
}
function RadialGradient$closestColor$lambda_1(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.laz_1 + b.iaz_1.laz_1) / 2;
}
function RadialGradient$closestColor$lambda_2(a, b) {
  return (b.haz_1 - a.haz_1) * (a.iaz_1.maz_1 + b.iaz_1.maz_1) / 2;
}
var RadialGradientClass;
function RadialGradient() {
  if (RadialGradientClass === VOID) {
    class $ {
      db2() {
        if (this.faz_1.i1())
          return Companion_getInstance_1().saz_1;
        if (this.faz_1.p1() === 1)
          return this.faz_1.q1(0).iaz_1;
        var tmp = asSequence(this.faz_1);
        var tmp_0 = sum(zipWithNext(tmp, RadialGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.faz_1);
        var tmp_2 = sum(zipWithNext(tmp_1, RadialGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.faz_1);
        var tmp_4 = sum(zipWithNext(tmp_3, RadialGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.faz_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, RadialGradient$closestColor$lambda_2)));
      }
    }
    initMetadataForClass($, 'RadialGradient');
    RadialGradientClass = $;
  }
  return RadialGradientClass;
}
var FadingColorClass;
function FadingColor() {
  if (FadingColorClass === VOID) {
    class $ {
      constructor(base, alternate) {
        this.db0_1 = base;
        this.eb0_1 = alternate;
      }
      db2() {
        return this.db0_1;
      }
      wcy(mapper) {
        return new (FadingColor())(mapper(this.db0_1), mapper(this.eb0_1));
      }
      toString() {
        return 'FadingColor(base=' + this.db0_1.toString() + ', alternate=' + this.eb0_1.toString() + ')';
      }
      hashCode() {
        var result = this.db0_1.hashCode();
        result = imul(result, 31) + this.eb0_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FadingColor()))
          return false;
        if (!this.db0_1.equals(other.db0_1))
          return false;
        if (!this.eb0_1.equals(other.eb0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FadingColor');
    FadingColorClass = $;
  }
  return FadingColorClass;
}
function darken(_this__u8e3s4, ratio) {
  return _this__u8e3s4.wcy((it) => it.hcz(ratio));
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Color as Color17ck47lkedxoy,
  FadingColor as FadingColor3d6ef6zcqmlhk,
  LinearGradient as LinearGradient2qftccjwl6uey,
  RadialGradient as RadialGradient3ic79yys0k1fp,
  applyAlpha as applyAlpha3k2fcxahu1lgz,
  darken as darken120sc580p6xj9,
  Companion_getInstance_1 as Companion_getInstancenv8qpb0wanrh,
  Companion_getInstance_0 as Companion_getInstance344l9hiw99vvc,
};
//endregion

//# sourceMappingURL=Paint.mjs.map
